/**
 * インシデント画面の文言（第3周 H-05/H-06/H-07・M-17・L-07）。
 * inc.report / inc.reportHint / inc.personalHint / inc.receivedDone は i18n.ts の定義を上書きする。
 */
export const ja: Record<string, string> = {
  "inc.report": "インシデントを報告する",
  "inc.reportHint": "まず電話で連絡し、そのあとここに記録を残してください（インシデント対応手順書）。受付番号と受付日時は自動で付きます。",
  "inc.personalHint": "分からなければチェックを付けたままにしてください。個人情報保護委員会などへの報告が要るかを判断するのに使います。",
  "inc.receivedDone": "受け付けました（受付番号 {no}）。この番号は「通知」と「インシデント > 自分の報告」でいつでも確かめられます。",
};

export const en: Record<string, string> = {
  "inc.report": "Report an incident",
  "inc.reportHint": "Phone first, then record it here (incident response procedure). A reference number and time are added automatically.",
  "inc.personalHint": "If you are not sure, leave this ticked. It is used to decide whether the incident must be reported to authorities.",
  "inc.receivedDone": "Received (reference no. {no}). You can find it any time under Notifications and Incidents › My reports.",
};
